export type RegistrationStatus = 'INVITE_PENDING' | 'SELF_REG_CONF' | 'TOKEN_REG_CONF' | 'INVITE_ACCEPTED';

export const RegistrationStatus = {
  INVITEPENDING: 'INVITE_PENDING' as RegistrationStatus,
  SELFREGCONF: 'SELF_REG_CONF' as RegistrationStatus,
  TOKENREGCONF: 'TOKEN_REG_CONF' as RegistrationStatus,
  INVITEACCEPTED: 'INVITE_ACCEPTED' as RegistrationStatus,
};
